import { locale, t } from "./i18n";

// When a reminder can be for, and how to say when one is.

function at(day: Date, hour: number): Date {
  const d = new Date(day);
  d.setHours(hour, 0, 0, 0);
  return d;
}

// remindPresets are the usual times to be reminded, from now.
export function remindPresets(now = new Date()): { label: string; at: Date }[] {
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const monday = new Date(now);
  monday.setDate(now.getDate() + (((8 - now.getDay()) % 7) || 7));
  return [
    { label: t("In 20 minutes"), at: new Date(now.getTime() + 20 * 60_000) },
    { label: t("In 1 hour"), at: new Date(now.getTime() + 60 * 60_000) },
    { label: t("In 3 hours"), at: new Date(now.getTime() + 3 * 60 * 60_000) },
    { label: t("Tomorrow at 9:00"), at: at(tomorrow, 9) },
    { label: t("Next Monday at 9:00"), at: at(monday, 9) },
  ];
}

// whenLabel says when a time is, near now: "today at 3:00 PM",
// "tomorrow at 9:00 AM", or "Mon, Oct 26 at 9:00 AM".
export function whenLabel(when: Date, now = new Date()): string {
  const time = when.toLocaleTimeString(locale, { hour: "numeric", minute: "2-digit" });
  const days = Math.round((at(when, 0).getTime() - at(now, 0).getTime()) / 86_400_000);
  if (days === 0) return t("today at {time}", { time });
  if (days === 1) return t("tomorrow at {time}", { time });
  if (days === -1) return t("yesterday at {time}", { time });
  const date = when.toLocaleDateString(locale, { weekday: "short", month: "short", day: "numeric", ...(when.getFullYear() !== now.getFullYear() ? { year: "numeric" } : {}) });
  return t("{date} at {time}", { date, time });
}

// localInput is a time as a datetime-local input's value.
export function localInput(t: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}T${p(t.getHours())}:${p(t.getMinutes())}`;
}
